import { makeAutoObservable } from "mobx";

export interface ActivityRecord {
  id: string;
  [key: string]: unknown;
}

export class JobsStore {
  jobs: ActivityRecord[] = [];
  newJobs: ActivityRecord[] = [];
  isReload = true;
  loading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  setJobs(jobs: ActivityRecord[]): void {
    this.isReload = false;
    this.jobs = jobs;
  }

  isLoading(): boolean {
    return this.loading;
  }

  setReload(isReload: boolean): void {
    this.isReload = isReload;
    // Replace (don't mutate in place): @smartsuite/grid memoizes its
    // virtualization range index by the records array identity, so an
    // in-place `length = 0` leaves stale indexes pointing past the
    // shrunken array (getRecordKey(undefined) crash on History open).
    this.jobs = [];
  }

  setLoading(loading: boolean): void {
    this.loading = loading;
  }

  setNewJobs(newJobs: ActivityRecord[]): void {
    this.newJobs = newJobs;
  }
}
